import React, { useEffect, useState } from "react";
import { Tabs, TabPane } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SingleEventNote from './SingleEventNote';
import AddEventNote from "./EventNotes/AddEventNote";
import { removeEventNote } from "../../../redux/admin/EventActions";
import { getActiveAgentId } from "../../../redux/admin/UserReducer";
import _ from 'lodash';
import BookedVisitsInfo from "./BookedVisitsInfo";
import { getCurrentEventInfo } from "../../../redux/admin/SalesAgentsQueueReducer";
import { getEventSelectedTab, getModalSelectedFrom } from "../../../redux/admin/EventReducer";

export default function EventNotes({
                                       event_id,
                                       removeVisit,
                                       showMessage,
                                       sendEmailForVisitInfoToUser,
                                       editVisit,
                                       openScheduleVisit,
                                       updateVisit,
                                       updateAssetData,
                                       viewMode,
                                       activeTabState,
                                       event  
                                   }) {

  const [activeKey, setActiveKey] = useState(activeTabState || "1"); // Use activeTabState if provided, default to "1"

  const eventNotes = useSelector(state => state.event?.eventNoteMap[event_id]?.eventNoteList);
  const totalCount = useSelector(state => state.event?.eventNoteMap[event_id]?.totalEventNoteCount);
  const isRemovingNote = useSelector(state => state.event.isRemovingNote);
  const isUpdatingNote = useSelector(state => state.event.isUpdatingNote);
  const activeAgentId = useSelector(state => getActiveAgentId(state));
  const totalAgentMap = useSelector(state => state.user.totalAgentMap);
  const selectedTab = useSelector(state=>getModalSelectedFrom(state))

  const [editNote, setNote] = useState({});

  const dispatch = useDispatch();

  const isInsideAgent = () => {
    if(selectedTab=="allLeads"){
      return true
    }
    return activeAgentId === event.agent_id;
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  // const filterEventNotes = () => {  
  //   const insideSalesAgents = Object.values(totalAgentMap)
  //   .filter(agent => agent?.designation === "Inside Sales Executive" || agent?.designation === "Manager - Inside Sales")
  //   .map(agent => agent._id || agent.id);  
  //   if (isInsideAgent()) {
  //     return eventNotes;
  //   } else {
  //     return eventNotes?.filter(note => note.agent_id === event.agent_id || note.agent_id === activeAgentId || insideSalesAgents.includes(note.agent_id)
  //     );
  //   }
  // };

const visitAgentGroups = [
  {
    name: "Gurgaon",
    agents: [
  "6a573adf6474a1001f863b63",
  "6a733935caeec0001fd9e3f8",
  "69b7ce300a358c001ff15cf0",
  "6482f75be2ae96e12caaf24b",
  "6a9fb7737104c20020c112d2",
  "641a8fceb15be7c16bc493cf",
  "58b6acd1f36d281facb75688"
    ]
  },

  {
    name: "Delhi",
    agents: [
    ]
  }
];

const filterEventNotes = () => {
  const insideSalesAgents = Object.values(totalAgentMap)
    .filter(
      agent =>
        agent?.designation === "Inside Sales Executive" ||
        agent?.designation === "Manager - Inside Sales"
    )
    .map(agent => agent._id || agent.id);


  if (insideSalesAgents.includes(activeAgentId)) {
    return eventNotes;
  }


  const activeAgentGroup = visitAgentGroups.find(group =>
    group.agents.includes(activeAgentId)
  );

  if (activeAgentGroup) {
    return eventNotes?.filter(note => {
      if (note.agent_id === activeAgentId) {
        return true;
      }

      if (activeAgentGroup.agents.includes(note.agent_id)) {
        return true;
      }

      if (insideSalesAgents.includes(note.agent_id)) {
        return true;
      }

      return false;
    });
  }

  return eventNotes?.filter(note => {
    if (note.agent_id === activeAgentId) {
      return true;
    }

    if (insideSalesAgents.includes(note.agent_id)) {
      return true;
    }

    return false;
  });
};




  const handleSetEditNote = (note) => {
    setNote(note);
    setActiveKey("3"); 
  };

  const handleRemoveNote = (note_id) => {
    dispatch(removeEventNote(event_id, note_id));
  };

  useEffect(() => {
    if (activeTabState) {
      setActiveKey(activeTabState); 
    }
  }, [activeTabState]);

  const items = [
    {
      key: '1',
      label: 'Active Notes',
      children:  <table className="table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Note</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {filterEventNotes()?.map(note => (
          <SingleEventNote
            key={note._id}
            note={note}
            isRemovingNote={isRemovingNote}
            isUpdatingNote={isUpdatingNote}
            setEditNote={handleSetEditNote} // Pass handleSetEditNote function
            removeNote={handleRemoveNote}
            activeAgentId={activeAgentId}
            totalAgentMap={totalAgentMap}
          />
        ))}
      </tbody>
    </table>,
    },
    {
      key: '2',
      label: 'Manage Visits',
      children:   <BookedVisitsInfo
      viewMode={viewMode}
      showMessage={showMessage}
      sendEmail={sendEmailForVisitInfoToUser}
      editVisit={editVisit}
      openScheduleVisit={openScheduleVisit}
      removeVisit={removeVisit}
      updateVisit={updateVisit}
      updateAssetData={updateAssetData}
    />,
    },
    {
      key: '3',
      label: 'Add Note',
      children:  <AddEventNote
      event_id={event_id}
      isUpdatingNote={isUpdatingNote}
      editNote={!_.isEmpty(editNote) ? editNote : null}
    />,
    },
  ];

  return (
        <Tabs activeKey={activeKey} onChange={handleTabChange} items={items}/>
    
    
    
  );
}



